// Module
var code = "<input class=\"form-control\" ng-model=\"model[options.key]\" ng-readonly=\"to.readonly\"> <span ng-if=\"to.helpText\" class=\"help-block\">{{to.helpText}}</span>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/input/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;